let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iJz71")).then(() => parcelRequire('irzXr'));